import { render, staticRenderFns } from "./NameEdit.vue?vue&type=template&id=538df51e&"
import script from "./NameEdit.vue?vue&type=script&lang=js&"
export * from "./NameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports